import { FC, memo } from 'react';
import { useRecoilState } from 'recoil';
import {
	Grid, Stepper, Step, StepLabel, Typography, Box
} from '@mui/material';
import { onboardStepState } from '../../../../atoms';
import { Logo } from '../../../../components';
import { StyledStepConnector, StyledStepIcon } from './components';

export const Nav: FC = memo(() => {
	const [step] = useRecoilState(onboardStepState);
	const isIPC = window.location.pathname.startsWith('/ipc');

	if (isIPC) {
		return null;
	}

	return (
		<Box
			sx={{
				padding: 1,
				margin: 0,
				height: (theme) => theme.dimensions.navHeight,
				position: 'absolute',
				top: 0,
				right: 0,
				left: 0,
				width: '100%',
				zIndex: 1201,
				background: 'linear-gradient(95deg, #1A6AE1 0%, #158DEB 50%, #257CFF 100%)',
			}}
		>
			<Grid container justifyContent='space-evenly' alignItems='center'>
				<Grid
					item
					xs={2}
					container
					direction='column'
				>
					<Logo />
					<Grid sx={{ mt: 2 }} item container direction='column' justifyContent='center' alignItems='center'>
						<a href='tel:+18009585540' rel='noreferrer'>
							<Typography variant='caption' sx={{ color: '#fff', textDecoration: 'none', backgroundColor: 'transparent', zIndex: 9999 }}>
								1 (800) 958-5540
							</Typography>
						</a>
						<a href='mailto:support@pharmacymarketplace.com' target='_top' rel='noreferrer'>
							<Typography variant='caption' sx={{ color: '#fff', textDecoration: 'none', backgroundColor: 'transparent', zIndex: 9999 }}>
								support@pharmacymarketplace.com
							</Typography>
						</a>
					</Grid>
				</Grid>
				<Grid item xs={10}>
					<Stepper
						alternativeLabel
						activeStep={step - 1}
						connector={<StyledStepConnector />}
						sx={{ background: 'transparent' }}
					>
						{['Introduction', 'Pharmacy Registration']
							.map((label) => (
								<Step key={label}>
									<StepLabel StepIconComponent={StyledStepIcon}>
										{label}
									</StepLabel>
								</Step>
							))}
					</Stepper>
				</Grid>
			</Grid>
		</Box>
	);
});
